module.exports = __webpack_public_path__ + "static/media/04.Foreign Tour.48a8c41c.JPG";